/*
 * @Author: RYL
 * @Description: 
 * @Date: 2020-10-13 14:28:29
 * @LastEditTime: 2022-03-07 17:31:01
 */
import http from '@/axios/http'

export function getTerminalList(data) {
  return http({
    url: '/api2/dtu/list',
    method: 'post',
    data,
  })
}
// 条件查询终端
export function queryTerminal(data) {
  return http({
    // url: '/api2/dtu/query',
    url: '/api2/dtu/list',
    method:'post',
    data
  })
}
// 添加终端
export function addTerminal(data) {
  return http({
    url: '/api2/dtu/add',
    method: 'post',
    data,
  })
}

// 编辑终端
export function editTerminal(data) {
  return http({
    url: '/api2/dtu/edit',
    method: 'post',
    data,
  })
}

// 删除终端
export function deleteTerminal(data) {
  return http({
    url: '/api2/dtu/del',
    method: 'post',
    data,
  })
}

// 终端详情接口
export function terminalDetail(data) {
  return http({
    url: '/api2/dtu/details',
    method: 'post',
    data,
  })
}

// 根据设备Id查终端接口
export function getByDevice(data) {
  return http({
    url: '/api2/dtu/device/list',
    method: 'post',
    data,
  })
}

// 下发采集配置
export function monitor(data) {
  return http({
    // url: '/api2/monitor/dtu/variable',
    url: '/api2/monitor/variable',
    method: 'post',
    data,
  })
}

// 操作终端后对终端进行采集
export function monitorTerminal(data) {
  return http({
    url: '/api2/deviceConfig/iotConfig',
    method: 'post',
    data,
  })
}
